import { LoginModel } from "../../models/LoginModel";
import instance from "../api";
import { jwtDecode } from "jwt-decode";
import TokenService from "../authentication/token.service";

interface DecodedToken {
  unique_name: string;
}

export const addOrUpdateUserSettings = async (data: any) => {
  const response = await instance.post<any>("/Users/Settings", data);
  return response.data;
};

export const getUserSettings = async (userId: string) => {
  const response = await instance.get<any>(
    "/Users/GetUserSettingById?userId=" + userId,
  );
  return response.data;
};

export const getUserAccessById = async (userId: string) => {
  const response = await instance.get<any>(
    "/Users/GetUserAccessById?userId=" + userId,
  );
  return response.data;
};

// Helper to get logout URL from API
export const getLogoutUrlFromApi = async (): Promise<string | null> => {
  try {
    const response = await instance.get<any>("/auth/GetConnexiaUrl");
    return response.data?.data ?? null;
  } catch (error) {
    console.error("Failed to fetch logout URL:", error);
    return null;
  }
};

export const login = async (login: LoginModel) => {
  // check if user is already logged in
  const accessToken = TokenService.getLocalAccessToken();
  if (accessToken) {
    return "already logged in";
  }

  return await instance
    .get<any>("/Auth/GetAccessToken?referencetoken=" + login.reference)
    .then(async (response) => {
      const parsedData = response.data.data;
      if (parsedData.token && parsedData.token !== undefined) {
        TokenService.addOrUpdateLocalAccessToken(parsedData.token);
        localStorage.setItem("loginemail", parsedData.email);
        localStorage.setItem("userId", parsedData.userId);
        return "success";
      } else {
        //const logOutUrl = await getLogoutUrlFromApi();
        const logOutUrl = process.env.REACT_APP_LOGOUT_URL; //Temporary fix
        localStorage.clear();
        if (logOutUrl) window.location.assign(logOutUrl);
      }
    })
    .catch(async (error) => {
      console.warn(error);
      if (window.location.hostname === "localhost") {
        return "error";
      } else {
        //const logOutUrl = await getLogoutUrlFromApi();
        const logOutUrl = process.env.REACT_APP_LOGOUT_URL; //Temporary fix
        localStorage.clear();
        if (logOutUrl) window.location.assign(logOutUrl);
      }
    });
};

export const refershTokenApi = async () => {
  const response = await instance.post<any>("Auth/RefreshToken", {
    token: localStorage.getItem("access_token"),
  });
  const parsedData = response.data.data;
  if (parsedData.token && parsedData.token !== undefined) {
    localStorage.setItem("access_token", parsedData.token);
    localStorage.setItem("loginemail", parsedData.email);
    localStorage.setItem("userId", parsedData.userId);
    return "success";
  } else {
    //const logOutUrl = await getLogoutUrlFromApi();
    const logOutUrl = process.env.REACT_APP_LOGOUT_URL; //Temporary fix
    localStorage.clear();
    if (logOutUrl) window.location.assign(logOutUrl);
  }
};

export const decodeToken = (accessToken: string): DecodedToken | null => {
  if (!accessToken) return null;
  try {
    const decoded: DecodedToken = jwtDecode<DecodedToken>(accessToken);

    return decoded;
  } catch (error) {
    console.error("Invalid Token:", error);
    return null;
  }
};
